module.exports = __webpack_public_path__ + "assets/webgl/Assets_3_base_color.74f5cd04.jpg";